export const SORTABLE_JS_CDN = "https://cdnjs.cloudflare.com/ajax/libs/Sortable/1.14.0/Sortable.min.js"
export const VUE_DRAGGABLE_CDN = "https://cdnjs.cloudflare.com/ajax/libs/Vue.Draggable/2.20.0/vuedraggable.umd.min.js"
export const PDF_JS_CDN = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.10.377/pdf.min.js"